import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=3560b712&scoped=true"
import script from "./NotAllowed.vue?vue&type=script&lang=js"
export * from "./NotAllowed.vue?vue&type=script&lang=js"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=3560b712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3560b712",
  null
  
)

export default component.exports